import * as React from "react";
import { Block } from "kanopi-components/Block";
import { useStyletron } from "kanopi-components/theme/useStyletron";

const HighlightCircle: React.FC = ({ children }) => {
  const [, theme] = useStyletron();
  return (
    <Block
      margin="0 auto"
      width="164px"
      height="164px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      position="relative"
      borderRadius="50%"
      borderWidth={"1px"}
      borderColor={theme.colors.contentPrimary}
      color={theme.colors.contentPrimary}
      $style={{
        textAlign: "center",
        boxSizing: "border-box",
      }}
    >
      {children}
    </Block>
  );
};

export { HighlightCircle };
